export const namespaced = true;

export const state = () => ({
    orderId: null
});

export const getters = {
    getOrderId: state => state.orderId,
}

export const mutations = {
    mutateOrderId(state, orderId) {
        state.orderId = orderId
    }
};

export const actions = {
    setOrderId({commit}, orderId) {
        return new Promise((resolve, reject) => {
            commit('mutateOrderId', orderId);
            resolve()
        })
    }
};

